<template>
  <div class="topbar-search">
    <input
      type="text"
      :placeholder="$t('topBarSearch.placeholder')"
      v-model="value"
      ref="top-bar-search"
      @keyup.enter="showPopup" />

    <icon
      name="search"
      primaryColor="color-light"
      size="xs"
      @click.native="showPopup" />
  </div>
</template>

<script>
export default {
  name: 'topbar-search',
  data () {
    return {
      value: ''
    };
  },
  methods: {
    showPopup () {
      this.$bus.$emit('search-popup-display', this.value);
      this.value = '';
      this.$refs['top-bar-search'].blur();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.topbar-search {
  margin-left: 3rem;
  margin-right: auto;
  position: relative;

  input {
    background: transparent;
    border: 1px solid $color-border-primary;
    border-radius: $border-radius-small;
    font-size: 1.4rem;
    height: 3.6rem;
    outline: none;
    padding: 0 1.5rem;
    transition: all .25s ease-out;
    width: 35rem;

    &::-webkit-input-placeholder {
      color: $color-border-primary;
      font-style: italic;
    }

    &::-moz-placeholder {
      color: $color-border-primary;
      font-style: italic;
    }

    &:-ms-input-placeholder {
      color: $color-border-primary;
      font-style: italic;
    }

    &:-moz-placeholder {
      color: $color-border-primary;
      font-style: italic;
    }

    &:active,
    &:focus {
      background: $color-light;

      &::-webkit-input-placeholder {
        color: $color-text-light;
      }

      &::-moz-placeholder {
        color: $color-text-light;
      }

      &:-ms-input-placeholder {
        color: $color-text-light;
      }

      &:-moz-placeholder {
        color: $color-text-light;
      }

      & + svg {
        fill: $color-text-lightest!important;
      }
    }
  }

  svg {
    cursor: pointer;
    position: absolute;
    pointer-events: auto!important;
    right: 1.5rem;
    top: 1rem;
    transition: all .25s ease-out;
  }
}

@media (max-width: 1240px) {
  .topbar-search {
    margin-right: .5rem;

    input {
      width: 18rem;
    }
  }
}

@media (max-width: 640px) {
  .topbar-search {
    margin: 0;

    input {
      width: 100%!important;

      & + svg {
        fill: $color-text-lightest!important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TopBarSearch.vue